export function getBackTarget(pathname: string, isCustomer: boolean): string | null {
  if (pathname === '/spa-control/manuals-warranty' || pathname === '/spa-control/contact-us') {
    return null;
  }

  const subControl = pathname.match(/^\/spa-control\/([^/]+)\/.+/);
  if (subControl) return `/spa-control/${subControl[1]}`;

  const controlRoot = pathname.match(/^\/spa-control\/([^/]+)$/);
  if (controlRoot) return isCustomer ? '/my-spas' : `/spa/${controlRoot[1]}`;

  const subSpa = pathname.match(/^\/spa\/([^/]+)\/.+/);
  if (subSpa) return `/spa/${subSpa[1]}`;

  if (/^\/spa\/[^/]+$/.test(pathname)) return '/spas';
  if (/^\/user\/[^/]+$/.test(pathname)) return '/users';
  if (/^\/dealership\/[^/]+$/.test(pathname)) return '/dealerships';
  if (/^\/roles\/[^/]+$/.test(pathname)) return '/roles';
  if (/^\/user-groups\/[^/]+$/.test(pathname)) return '/user-groups';
  if (/^\/settings\/.+/.test(pathname)) return '/settings';

  const drawerPages = [
    '/home', '/spas', '/my-spas', '/users', '/dealerships', '/comments',
    '/news', '/dealer-promos', '/promos', '/notifications',
    '/logs', '/firmware', '/spa-commands', '/api-commands',
    '/roles', '/user-groups', '/permissions', '/settings',
    '/upgrade-requests',
  ];
  if (drawerPages.includes(pathname)) return '/';

  return null;
}
